import Constants from '~/components/Constants';

import ContactForm from './ContactForm';
import styles from './SharedSettings.style';

const MarketoSalesForm = ({ classes }) => (
  <div className={classes.root}>
    <ContactForm
      title="Marketo settings"
      body="Clearbit integrates directly with your existing Marketo forms. Contact our success team to learn more!"
      form_id={Constants.CONTACT_SALES_FORM_ID}
    />
  </div>
);

MarketoSalesForm.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(MarketoSalesForm);
